import { FC } from 'react';
import { useIntl } from 'react-intl';
import PruTable from 'src/app/common/components/PruTable/PruTable';
import { getDefaultDisplayDate } from 'src/app/common/utils';
import _ from 'lodash';
import { WalletAssignedAwardListRes } from 'src/app/modules/pruwallet/types/assigned-award-type';

type WalletAssignedAwardListProps = {
  isLoading: boolean;
  listRes?: WalletAssignedAwardListRes;
  onRefresh: () => void;
  onChangePage: (page: number, rowsPerPage: number) => void;
};

const WalletAssignedAwardList: FC<WalletAssignedAwardListProps> = ({ isLoading, listRes, onRefresh, onChangePage }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <>
      <PruTable
        disableBulkSelect
        title={Translation('walletAssignedAward.list')}
        headerBtnDef={[]}
        operationDef={[]}
        columnDef={[
          {
            isId: true,
            keyIndex: 'awardId',
            align: 'center',
            displayName: Translation('walletAssignedAward.common.awardId'),
            renderData: (row) => String(row.awardId ? row.awardId : ''),
          },
          {
            keyIndex: 'agentCode',
            align: 'center',
            displayName: Translation('walletAssignedAward.common.agentCode'),
            renderData: (row) => String(row.agentCode ? row.agentCode : ''),
          },
          {
            keyIndex: 'promoCode',
            align: 'center',
            displayName: Translation('walletAssignedAward.common.promoCode'),
            renderData: (row) => String(row.promoCode ? row.promoCode : ''),
          },
          {
            keyIndex: 'transactionDate',
            align: 'center',
            displayName: Translation('walletAssignedAward.common.transactionDate'),
            renderData: (row) => (row.transactionDate ? getDefaultDisplayDate(row.transactionDate, 'date') : ''),
          },
          {
            keyIndex: 'used',
            align: 'center',
            displayName: Translation('walletAssignedAward.common.used'),
            renderData: (row) => (row.used ? 'Y' : 'N'),
          },
        ]}
        isLoading={isLoading}
        onRefresh={onRefresh}
        dataSource={listRes?.data?.data}
        totalPages={listRes?.data?.totalPages}
        totalRecords={listRes?.data?.totalCount}
        onChangePage={onChangePage}
      />
    </>
  );
};

export default WalletAssignedAwardList;
